import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { NavLink, useLocation, useParams } from 'react-router-dom';
import { generateRouteUrl, getPublicFileUrl, isAuthenticated } from '../../library/constants';
import styles from './header-bar.module.scss';

const HeaderBar = ({ menu, projectId, language = 'en', name }) => {
    const { t } = useTranslation()
    const { quotationToken } = useParams()
    const location = useLocation()
    const isVisible = location.pathname.includes("dashboard") || location.pathname.includes("files") || location.pathname.includes("additional-quotation")

    return (
        <div className={styles.headerBar}>
            <>
                <div className={styles.nav}>{menu}</div>
                {!!projectId && (
                    <div className={styles.projectNumber}>
                        {isAuthenticated(quotationToken) && isVisible ? <div className={styles.topRight}>
                            <NavLink className={({ isActive, isPending }) =>
                                isPending ? styles.active : isActive ? styles.active : styles.inactive
                            } to={generateRouteUrl('Dashboard', {
                                quotationToken,
                            })} ><button className="button" ><img src="/icons/project-info.svg" width={13} height={13} alt="Dashboard" />{t("Dashboard")}</button></NavLink>
                            <NavLink className={({ isActive, isPending }) =>
                                isPending ? styles.active : isActive ? styles.active : styles.inactive
                            } to={generateRouteUrl('Files', {
                                quotationToken,
                            })}><button className="button" ><img src="/icons/files.svg" width={16} height={14} alt="Files" />{t("Files")}</button></NavLink>
                        </div> : <div></div>}
                        <div className={styles.projectMeta}>
                            <div className={styles.projectId}>
                                <img src="/icons/box.svg" alt="box" style={{ marginRight: '5px', verticalAlign: 'text-top' }} />
                                <span className={styles.projectLabel}>{t('Project ID')}: </span><strong>{String(projectId)}</strong>
                            </div>
                            <div className={styles.tooltip}>
                                <img
                                    src={getPublicFileUrl(`upload/flag/${language}.png`)}
                                    alt={language}
                                    style={{ width: 'auto', height: '1rem', cursor: 'pointer' }}
                                />
                                <div className={styles.tooltiptext}>{name}</div>
                            </div>
                        </div>
                    </div>
                )}
            </>
        </div>
    );
}

HeaderBar.propTypes = {
    menu: PropTypes.node,
    projectId: PropTypes.node,
    language: PropTypes.string,
}

export { HeaderBar };
